//@ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import qr from "qrcode";

type Props = {
  position: string;
  code: string;
  open: boolean;
  setIsOpen: (value: boolean) => void;
};

export const PositionPrinterDialog = (props: Props) => {
  const [qrUrl, setQrUrl] = useState("");
  var selected_device;
  var devices = [];

  function writeToSelectedPrinter(dataToWrite) {
    selected_device.send(dataToWrite, undefined, errorCallback);
  }

  var errorCallback = function (errorMessage) {
    alert("Error: " + errorMessage);
  };

  function onDeviceSelected(selected) {
    for (var i = 0; i < devices.length; ++i) {
      if (selected.value == devices[i].uid) {
        selected_device = devices[i];
        return;
      }
    }
  }
  useEffect(() => {
    function setup() {
      //Get the default device from the application as a first step. Discovery takes longer to complete.
      BrowserPrint.getDefaultDevice(
        "printer",
        function (device) {
          //Add device to list of devices and to html select element
          selected_device = device;
          devices.push(device);
          var html_select = document.getElementById("selected_device");
          var option = document.createElement("option");
          option.text = device.name;
          html_select.add(option);

          //Discover any other devices available to the application
          BrowserPrint.getLocalDevices(
            function (device_list) {
              for (var i = 0; i < device_list.length; i++) {
                //Add device to list of devices and to html select element
                var device = device_list[i];
                if (!selected_device || device.uid != selected_device.uid) {
                  devices.push(device);
                  var option = document.createElement("option");
                  option.text = device.name;
                  option.value = device.uid;
                  html_select.add(option);
                }
              }
            },
            function () {
              alert("Error getting local devices");
            },
            "printer"
          );
        },
        function (error) {
          alert(error);
        }
      );
    }
    setup();
  }, [props.open]);

  useEffect(() => {
    if (!props.code) return;
    const options = {
      errorCorrectionLevel: "H",
      type: "png", // Output type, can be 'svg', 'png', 'jpg', or 'dataURL'
      rendererOpts: { quality: 0.3 },
    };

    // Generate the QR code as a data URL
    qr.toDataURL(props.code, options, (err, url) => {
      if (err) throw err;

      // Display the data URL (you can use this in an <img> tag in HTML)
      setQrUrl(url);
    });
  }, [props.code]);

  return (
    <Dialog open={props.open} onClose={() => props.setIsOpen(false)}>
      <DialogContent>
        <div>
          <Typography variant="h6">Imprimir Etiqueta</Typography>
          Aparelho selecionado:
          <select
            id="selected_device"
            onChange={() => onDeviceSelected(this)}
          ></select>
          <br />
          <br />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={qrUrl} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setIsOpen(false)}>Cancelar</Button>
        <Button
          variant="contained"
          type="button"
          value="Send ZPL Label"
          onClick={() => {
            const zpl = `^XA
                ^FT299,1070^A0B,200,200^FH\^CI28^FD${props.position}^FS^CI27
                ^FT600,510^A0B,130,130^FH\^CI28^FD${props.code}^FS^CI27
                ^FO450,800^BQN,2,10^FDQA,${props.code}^FS
                ^PQ1,,,Y
                ^XZ`;
            writeToSelectedPrinter(zpl);
          }}
        >
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
